import Image from 'next/image'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import { SimpleCard } from 'app/KinerjaPSPegawaiPage/components/SimpleCard'

import type { FC, HTMLProps } from 'react'

type CardPanduanProps = Exclude<HTMLProps<HTMLDivElement>, 'children'>

const CardPanduan: FC<CardPanduanProps> = ({ className }) => {
  return (
    <SimpleCard className={clsx('h-fit p-5 select-none', className)}>
      <div className="flex items-center gap-4 mb-6">
        <Image
          src="/illustrations/img-document-penci-fill.png"
          width={48}
          height={48}
          alt=""
        />

        <Text variant="heading-lg">Panduan</Text>
      </div>

      <ul className="px-5 list-disc list-outside">
        <Text as="li">
          Diskusikan pengisian pendampingan bersama Tim Kinerja. Sehingga Tim
          Kinerja memiliki pemahaman yang cukup untuk memberikan hasil
          pemantauan.
        </Text>
        <Text as="li">
          Tim Kinerja akan memberikan hasil pemantauan dengan mempertimbangkan
          isi catatan pendampingan dan survei Kepala Sekolah.
        </Text>
      </ul>
    </SimpleCard>
  )
}

export default CardPanduan
